import React from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@garnish/constants';

import { ListItem } from '../List';
import { type LedgerRowProps } from './Ledger.types';
import { LedgerLabelText } from './LedgerLabelText';
import { LedgerRowLabel } from './LedgerRowLabel';

// ────────────────────────────────────────────────────────────────────────────

export const LedgerRow = (props: LedgerRowProps) => {
  const {
    label,
    amount,
    helperText,
    sizeMatch,
    isInvalid,
    testID,
    style,
    ...restProps
  } = props;

  return (
    <ListItem>
      <View style={[styles.ledgerItem, style]}>
        <View style={[styles.ledgerColumn, styles.ledgerColumnLeft]}>
          <LedgerRowLabel
            sizeMatch={sizeMatch}
            label={label}
            helperText={helperText}
            {...restProps}
          >
            <LedgerLabelText
              sizeMatch={sizeMatch}
              label={label}
              helperText={helperText}
              palette={isInvalid ? 'caution' : 'standard'}
              {...restProps}
            />
          </LedgerRowLabel>
        </View>

        <View style={[styles.ledgerColumn, styles.ledgerColumnRight]}>
          <LedgerRowLabel
            sizeMatch={sizeMatch}
            label={`${Array.isArray(amount) ? amount.join(' + ') : amount}`}
            alignment="right"
            testID={testID}
            {...restProps}
          >
            <LedgerLabelText
              sizeMatch={sizeMatch}
              label={`${Array.isArray(amount) ? amount.join(' + ') : amount}`}
              alignment="right"
              testID={testID}
              palette={isInvalid ? 'caution' : 'standard'}
              {...restProps}
            />
          </LedgerRowLabel>
        </View>
      </View>
    </ListItem>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  ledgerItem: {
    flexDirection: 'row',
    gap: theme.spacing['2'],
  },
  ledgerColumn: {
    flex: 1,
  },
  ledgerColumnLeft: {
    alignItems: 'flex-start',
  },
  ledgerColumnRight: {
    alignItems: 'flex-end',
  },
});
